import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HomeCarouselItemsModel} from '../../../models/home-carousel-items.model';
import {HomeCarouselModel} from '../../../models/home-carousel.model';
import {Subscription} from 'rxjs';
import {HomeCarouselService} from '../../../service/home-carousel.service';
import {Flat} from '../../../models/flat.model';

@Component({
  selector: 'app-flat-frontage-position-selector',
  templateUrl: './flat-front-select.component.html',
  styleUrls: ['./flat-front-select.component.scss']
})
export class FlatFrontSelectComponent implements OnInit {
  @Input() selectedFlat: Flat;
  @Output() positionSelected = new EventEmitter();
  homeCarouselItems: HomeCarouselModel[] = [];
  subscriptions: Subscription[] = [];

  constructor(private homeCarouselService: HomeCarouselService,) {

    this.subscriptions.push(this.homeCarouselService.homeCarouselItems.subscribe((carouselItems: HomeCarouselItemsModel) => {
      if (carouselItems && carouselItems.items) {
        this.homeCarouselItems = carouselItems.items;
      }
    }));

  }

  ngOnInit() {
  }



}
